export enum KeyCodes {
  TAB = 9,
  ENTER = 13,
  C = 67,
  SHIFT = 16,
  CTRL = 17,
  ALT = 18,
  ESCAPE = 27,
  END = 35,
  HOME = 36,
  LEFT = 37,
  UP = 38,
  RIGHT = 39,
  DOWN = 40,
  DECIMAL_POINT = 110,
  PERIOD = 190
}

export function downloadUrl(url: string, filename: string) {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
}

export function downloadCsv(content: string, filename: string) {
  downloadFile(content, 'text/csv', filename)
}

export function downloadFile(content: string, contentType: 'text/csv' | 'text/json', filename: string) {
  const a = document.createElement('a')
  var blob = new Blob([content], { type: contentType })
  a.href = URL.createObjectURL(blob)
  a.download = filename
  a.click()
}

export function isChild(parent: Element, child: Element): boolean {
  if (!child || !child.parentElement) {
    return false
  } else if (child === parent || child.parentElement === parent) {
    return true
  } else {
    return isChild(parent, child.parentElement)
  }
}

export function getScrollParent(element: HTMLElement): HTMLElement {
  const overflowY = window.getComputedStyle(element).overflowY
  const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden'

  if (isScrollable && element.scrollHeight >= element.clientHeight) {
    return element
  } else if (element.parentElement) {
    return getScrollParent(element.parentElement)
  } else {
    return document.body
  }
}

export function getFixedPositionOffsetParent(element: HTMLElement) {
  if (!element || !element.parentElement) {
    return document.documentElement
  }

  let el: HTMLElement | null = element.parentElement
  while (el && window.getComputedStyle(el).transform === 'none') {
    el = el.parentElement
  }
  return el || document.documentElement
}

export function stopPastePropagation(evt: React.ClipboardEvent) {
  evt.stopPropagation()
}
